import { z } from "zod";

/**
 * What the product means by "organization" on the wire — not the row.
 * Deliberately excludes `retentionDays` and `monthlyBudgetUsd`: those are
 * agency-set operational controls, not something every client-facing
 * surface needs, and adding them later is a schema change here, not a
 * migration (see PLAN.md "Transport contracts are not domain contracts").
 */
export const organizationDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  slug: z.string(),
  createdAt: z.string().datetime(),
});

export type OrganizationDto = z.infer<typeof organizationDtoSchema>;
